<template>
<div class="chapter">
<div class="inner_page">
<h1>The Britt Montero Series</h1>
<h2 class="sigil_not_in_toc" style="text-align: center;">Edna Buchanan</h2>
<h4 style="text-align:center;"><br/>
<a href="#/Text/ContentsUnderPressure">Contents Under Pressure</a><br/>
<span href="#/Text/MiamiItsMurder" title="Link target outside of Sample">Miami, It’s Murder</span><br/>
<span href="#/Text/SuitableForFraming" title="Link target outside of Sample">Suitable for Framing</span><br/>
<span href="#/Text/ActOfBetrayal" title="Link target outside of Sample">Act of Betrayal</span><br/>
<span href="#/Text/MarginOfError" title="Link target outside of Sample">Margin of Error</span><br/></h4>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// BrittMontero.vue?346fa3e0